import { v4 as uuidv4 } from "uuid";
import { addNotification } from "./creators";

export const addNotificationWithTimeout = (notification_type, message, title = "") => {
  return (dispatch) => {
    const id = uuidv4();
    dispatch(addNotification(notification_type, message, id, title));
  };
};
